import { ARCHIVED_ASSETS_LIFECYCLE_ENABLED_FLAG } from '@terra/shared-contracts-feature-flags';
import {
  areArchivedListMutationsDisabled,
  resolveLifecycleStateQuery,
  type LifecycleStateFilterDto,
} from '@terra/shared-dto-types';
import { useFeatureFlags } from './useFeatureFlags';

export function useArchivedLifecycleFilter({
  lifecycleState,
  lifecycleStateOverride,
}: {
  lifecycleState: LifecycleStateFilterDto;
  lifecycleStateOverride?: LifecycleStateFilterDto;
}) {
  const { isFeatureFlagEnabled } = useFeatureFlags(
    ARCHIVED_ASSETS_LIFECYCLE_ENABLED_FLAG,
  );
  const lifecycleQueryParam = resolveLifecycleStateQuery({
    isEnabled: isFeatureFlagEnabled,
    lifecycleState,
  });
  const hasLifecycleOverride = lifecycleStateOverride != null;

  return {
    isLifecycleUiEnabled: isFeatureFlagEnabled,
    lifecycleQueryParam,
    showLifecycleSelector: isFeatureFlagEnabled && !hasLifecycleOverride,
    areArchivedMutationsDisabled: areArchivedListMutationsDisabled({
      lifecycleQueryParam,
      hasLifecycleOverride,
    }),
  };
}
